import React from "react";
import PropTypes from "prop-types";

function Dropdown({ filter, selected, handleChange }) {
  const dropdownOptions = filter && filter.get("options");

  if (!dropdownOptions || dropdownOptions.size < 1) {
    return null;
  }

  return (
    // eslint-disable-line
    <select
      value={selected}
      onChange={event =>
        handleChange({
          event,
          filterTicker: filter.get("filterTicker"),
          optionTicker: event.target.value,
        })
      }>
      {dropdownOptions.map((dropdownOption, index) => (
        <option value={dropdownOption.get("optionTicker")} key={index}>
          {dropdownOption.get("optionName")}
        </option>
      ))}
    </select>
  );
}

Dropdown.propTypes = {
  filter: PropTypes.object,
  selected: PropTypes.array,
  handleChange: PropTypes.func,
};

export default Dropdown;
